import ErrorBoundary from '@patientpattern/coat/ui/ErrorBoundary';
import {QueryClientProvider} from '@tanstack/react-query';
import {ReactQueryDevtools} from '@tanstack/react-query-devtools';
import axios from 'axios';
import {createRoot} from 'react-dom/client';

import css from './index.module.scss';

import queryClient from 'app/queryClient';

export async function prepare(isDev: boolean) {
    axios.defaults.baseURL = import.meta.env.HAL_API_URL;
    axios.defaults.withCredentials = true;

    if (isDev) {
        const {worker} = await import('./mocks/browser');

        return worker.start({quiet: true});
    }

    return Promise.resolve();
}

export function render(children: JSX.Element) {
    createRoot(document.getElementById('root')!).render(
        <QueryClientProvider client={queryClient}>
            <ErrorBoundary className={css.error}>{children}</ErrorBoundary>
            <ReactQueryDevtools position="bottom-right" />
        </QueryClientProvider>,
    );
}
